import { FormControl, FormHelperText } from "@mui/material";
import { Box } from "@mui/system";
import { DatePicker } from "@mui/x-date-pickers";
import React from "react";
import { Controller } from "react-hook-form";
import style from "./Input.module.css";

const FormInputDatePicker = ({
  name,
  label,
  control,
  rules,
  error,
  onChange = () => void 0,
}) => {
  return (
    <Box className={style.control}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <FormControl>
            <DatePicker
              label={label}
              value={field.value}
              onChange={(value) => {
                field.onChange(value);
                onChange();
              }}
              onError={(newError) => (error = newError)}
              slotProps={{
                textField: { size: "small" },
              }}
            />
            {error !== undefined && (
              <FormHelperText error margin="dense">
                {error}
              </FormHelperText>
            )}
          </FormControl>
        )}
      />
    </Box>
  );
};

export default FormInputDatePicker;
